import { MultiDietGuideType } from "@/features/static-builder/types/multidiet-guide.type";
import { interpretColors } from "@/lib/helpers/typography";
import { cn } from "@/lib/utils";
import React from "react";

type Props = {
  data: MultiDietGuideType;
  ref: React.RefObject<(HTMLDivElement | null)[]>;
};

export const MultiDietGuideDescCards = ({ data, ref }: Props) => {
  return (
    <>
      {data.descriptions.map((desc, index) => (
        <div
          key={desc.id}
          ref={(el: HTMLDivElement | null) => {
            ref.current[index] = el;
          }}
          className="absolute top-0 opacity-0 bg-brand-grey1 p-6 rounded-xl flex flex-col gap-16"
        >
          <div>
            {desc.text?.map((paragraph, paraIdx) => {
              const isLastParagraph =
                index === data.descriptions.length - 1 &&
                paraIdx === desc.text.length - 1;
              return (
                <p
                  key={paraIdx}
                  className={cn(
                    `text-brand-green-2 text-lg last:pt-6`,
                    isLastParagraph && `last:pt-0`
                  )}
                >
                  {paragraph.children.map((child, childIdx) => (
                    <span
                      key={childIdx}
                      className={cn(child.bold && "font-bold")}
                      dangerouslySetInnerHTML={{
                        __html: interpretColors(child.text),
                      }}
                    />
                  ))}
                </p>
              );
            })}
          </div>
          <div className="flex gap-3">
            {Array.from({ length: index + 1 }).map((_, dotIdx) => (
              <span
                key={dotIdx}
                className={cn(
                  "w-5 h-5 rounded-full",
                  dotIdx === 0
                    ? "bg-brand-red"
                    : dotIdx === 1
                      ? "bg-brand-violet"
                      : "bg-brand-yellow-dark"
                )}
              />
            ))}
          </div>
        </div>
      ))}
    </>
  );
};
